// AgeVerifier.js
import { connect } from 'react-redux';
import AgeVerifier from '../component/AgeVerifier.jsx';
import removeModals from '../action/removeModals.js';
import submitAnonymousLogin from '../action/submitAnonymousLogin.js';
import login from '../action/login.js';

import getNetworkingData from '../selector/getNetworkingData.js';

const mapStateToProps = state => {
  return {
    isAnonymousLoginFetching: getNetworkingData(
      state,
      ['submit', 'login', 'anonymous'],
      'isFetching'
    ),
  };
};

function mapDispatchToProps(dispatch) {
  return {
    closeModal: () =>
      dispatch(
        removeModals({ ids: ['AgeVerifierModal'], transitionStatus: 'closing' })
      ),
    login: () => dispatch(login({ isRequireDiamond: true })),
    submitAnonymousLogin: () => dispatch(submitAnonymousLogin()),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(AgeVerifier);
